<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <div id="financial-responsible-page" class="qi-content">
        <header>
          <h1>Seleção de Responsável Financeiro e Estudante</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row>
          <vs-input
            label="CPF/CNPJ do Responsável: "
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="client.CGCCFO"
            v-on:keyup.13="findClient(client.CGCCFO)"
            :disabled="isTaxCpfLocked"
          />
          <vs-input
            v-if="client.CGCCFO.length <= 14"
            type="date"
            label="Data de nascimento do Responsável: "
            v-model="nascClient"
            v-on:keyup.13="findClient(client.CGCCFO)"
          />
          <vs-checkbox
            style="margin-top: 10px"
            v-model="responsibleIsStudent"
            v-on:change="resetDataIfNeeded()"
            v-if="!studentAlreadySelected"
          >
            <span>Responsável Financeiro será o aluno.</span>
          </vs-checkbox>
        </vs-row>
        <vs-row style="margin-top: 10px">
          <vs-button
            style="width: 100%; margin: 5px 0"
            icon="search"
            @click="findClient(client.CGCCFO)"
          >
            Localizar
          </vs-button>
        </vs-row>
        <vs-row v-if="isEmancipated">
          <vs-checkbox
            style="margin-top: 10px"
            v-model="responsibleEmancipated"
            v-on:change="formClient(isEmancipated)"
          >
            <span>Emancipado</span>
          </vs-checkbox>
          <vs-divider />
        </vs-row>
        <!-- FORMULÁRIO CLIENTE -->
        <vs-row>
          <vs-card style="margin-top: 10px" v-if="showClientForm">
            <div slot="header">
              <h3>Informações do Cliente</h3>
            </div>
            <vs-alert
              v-if="client.INADIMPLENTE == '1'"
              title="Aviso de Inadimplência"
              color="danger"
              style="margin-bottom: 15px;"
            >
              {{ client.MSGINADIMPLENTE ? client.MSGINADIMPLENTE : 'Cliente não pode ser selecionado, pois o mesmo consta como inadimplente.' }}
            </vs-alert>
            <div class="spacing-children">
              <form>
                <vs-row>
                  <vs-col vs-w="8" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="NOME"
                      type="text"
                      v-model="client.NOME"
                      label="Nome Completo"
                      :disabled="disableClientForm"
                      :danger="!client.NOME.length > 0"
                      danger-text="Campo obrigatório!"
                      v-on:blur="getNameStudent(client.NOME)"
                    />
                  </vs-col>
                  <vs-col vs-w="4" vs-xs="12" vs-type="flex">
                    <vs-select
                      width="100%"
                      name="PESSOAFISOUJUR"
                      v-model="client.PESSOAFISOUJUR"
                      label="Tipo de Pessoa"
                      :disabled="disableClientForm"
                    >
                      <vs-select-item value="F" text="Pessoa Física" />
                      <vs-select-item value="J" text="Pessoa Jurídica" />
                    </vs-select>
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="NOMEFANTASIA"
                      type="text"
                      v-model="client.NOMESOCIAL"
                      label="Nome Fantasia"
                      :disabled="disableStudentForm"
                      :danger="!client.NOMESOCIAL.length > 0"
                      danger-text="Campo obrigatório!"
                      v-on:blur="getNameSocialStudent(client.NOMESOCIAL)"
                    />
                  </vs-col>
                  <vs-col vs-w="4" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="DTNASCIMENTO"
                      type="date"
                      v-if="client.PESSOAFISOUJUR != 'J'"
                      v-model="client.DTNASCIMENTO"
                      label="Data de Nascimento"
                      :danger="
                        client.DTNASCIMENTO == '' ||
                        (validClientAge(client.DTNASCIMENTO) &&
                          client.EMANCIPADO != 'S')
                      "
                      danger-text="Campo obrigatório para pessoa física"
                      v-on:blur="getDateStudent(client.DTNASCIMENTO)"
                    />
                  </vs-col>

                  <vs-col vs-w="2" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="CGCCFO"
                      type="text"
                      v-model="client.CGCCFO"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      label="CPF/CNPJ"
                      :disabled="disableStudentForm"
                      :danger="!client.CGCCFO.length > 0"
                      danger-text="Campo obrigatório!"
                      v-on:blur="getCPFStudent(client.CGCCFO)"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="TELEFONE"
                      type="text"
                      v-model="client.TELEFONE"
                      v-mask="'(##) ####-#####'"
                      label="Telefone 1"
                      :danger="
                        !validTelephone(client.TELEFONE) ||
                        client.TELEFONE == client.TELEX
                      "
                      v-on:blur="
                        responsibleIsStudent || responsibleEmancipated
                          ? validTelephone(client.TELEFONE) &&
                            client.TELEFONE != client.TELEX
                            ? getTelefone(client.TELEFONE)
                            : ''
                          : ''
                      "
                      danger-text="Campo obrigatório, os telefones devem ser diferentes"
                    />
                  </vs-col>

                  <vs-col vs-w="6" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="TELEX"
                      type="text"
                      v-model="client.TELEX"
                      v-mask="'(##) ####-#####'"
                      label="Telefone 2"
                      :danger="
                        !validTelephone(client.TELEX) ||
                        client.TELEFONE == client.TELEX
                      "
                      v-on:blur="
                        responsibleIsStudent || responsibleEmancipated
                          ? validTelephone(client.TELEX) &&
                            client.TELEFONE != client.TELEX
                            ? getTelex(client.TELEX)
                            : ''
                          : ''
                      "
                      danger-text="Campo obrigatório, os telefones devem ser diferentes"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-type="flex">
                    <vs-input
                      name="EMAIL"
                      type="email"
                      v-model="client.EMAIL"
                      label="E-Mail"
                      :danger="
                        !client.EMAIL.length > 0 || !validEmail(client.EMAIL)
                      "
                      v-on:blur="
                        responsibleIsStudent || responsibleEmancipated
                          ? client.EMAIL.length > 0 && validEmail(client.EMAIL)
                            ? getEmail(client.EMAIL)
                            : ''
                          : ''
                      "
                      danger-text="Campo obrigatório, informe um e-mail válido."
                    />
                  </vs-col>
                </vs-row>
                <div>
                  <vs-divider />
                  <vs-row>
                    <h3>Endereço do Cliente</h3>
                  </vs-row>
                  <vs-row>
                    <vs-col
                      v-if="this.errorCEP == true"
                      vs-type="flex"
                      vs-w="12"
                    >
                      <vs-button
                        icon="highlight_off"
                        @click="discoverAddress()"
                      >
                        Não sabe o CEP
                      </vs-button>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="2" vs-xs="12">
                      <vs-input
                        name="CEP"
                        type="text"
                        v-mask="'########'"
                        v-model="client.CEP"
                        label="CEP"
                        :danger="!validCEP(client.CEP)"
                        danger-text="Informe um CEP válido."
                        v-on:blur="getAddressByCEP(client.CEP)"
                      ></vs-input>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="7" vs-xs="12">
                      <vs-input
                        name="RUA"
                        type="rua"
                        v-model="client.RUA"
                        label="Rua"
                        :danger="
                          !client.RUA.length > 0 || client.RUA.length > 60
                        "
                        danger-text="O campo endereço não pode ser vazio ou ter mais que 60 caracteres!"
                      ></vs-input>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="1" vs-xs="6">
                      <vs-input
                        name="NUMERO"
                        type="text"
                        v-model="client.NUMERO"
                        label="Número"
                        :danger="!client.NUMERO.length > 0"
                        danger-text="Informe um número válido."
                      ></vs-input>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="2" vs-xs="6">
                      <vs-input
                        name="COMPLEMENTO"
                        type="text"
                        v-model="complement"
                        label="Complem."
                      ></vs-input>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-w="3" vs-xs="12" vs-type="flex">
                      <vs-select
                        name="ESTADO"
                        width="100%"
                        v-model="client.ESTADO"
                        :danger="client.ESTADO == ''"
                        danger-text="Estado obrigatório!"
                        label="Estado"
                        v-on:input="changeProvinces($event)"
                      >
                        <vs-select-item
                          v-for="(option, i) in selectESTADOcli"
                          :key="i"
                          :value="option.CODIGO"
                          :text="option.NOME"
                        >
                        </vs-select-item>
                      </vs-select>
                    </vs-col>

                    <vs-col vs-w="4" vs-xs="12" vs-type="flex">
                      <vs-select
                        name="CODMUNICIPIO"
                        width="100%"
                        v-model="client.CODMUNICIPIO"
                        label="Cidade"
                        :danger="
                          client.CODMUNICIPIO == '' ||
                          client.CODMUNICIPIO == '-'
                        "
                        danger-text="Cidade obrigatória!"
                      >
                        <vs-select-item
                          v-for="(municipio, i) in selectCODMUNICIPIOcli"
                          :key="i"
                          :value="municipio.value.CODIGO"
                          :text="municipio.title"
                        />
                      </vs-select>
                    </vs-col>
                    <vs-col vs-w="4" vs-xs="12" vs-type="flex">
                      <vs-input
                        name="BAIRRO"
                        type="text"
                        v-model="client.BAIRRO"
                        label="Bairro"
                        :danger="!client.BAIRRO.length > 0"
                        danger-text="Informe o bairro."
                      ></vs-input>
                    </vs-col>
                  </vs-row>
                </div>
              </form>
            </div>
          </vs-card>
        </vs-row>

        <vs-row
          v-if="
            client.NOME != '' &&
            !showStudentForm &&
            !responsibleIsStudent &&
            student.NOME == ''
          "
        >
          <vs-col>
            <h2 class="mb ml">Estudante</h2>
            <vs-row>
              <vs-col>
                <vs-input
                  label="CPF do Estudante: *"
                  v-mask="'###.###.###-##'"
                  v-model="student.CPFCNPJ"
                  v-on:keyup.13="findStudent(student.CPFCNPJ)"
                />
                <vs-input
                  type="date"
                  label="Data de nascimento do Estudante: *"
                  v-model="nascStudent"
                  v-on:keyup.13="findStudent(student.CPFCNPJ)"
                />
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-button
                icon="search"
                style="width: 100%"
                @click="findStudent(student.CPFCNPJ)"
              >
                Localizar Estudante
                </vs-button>
            </vs-row>
          </vs-col>
        </vs-row>

        <!-- FORMULÁRIO ESTUDANTE -->
        <vs-row>
          <vs-card style="margin-top: 10px" v-if="showStudentForm">
            <div slot="header">
              <h3>
                Informações do Estudante
                <span v-if="student.RA != ''">- RA: {{ student.RA }}</span>
              </h3>
            </div>

            <vs-alert
              v-if="student.INADIMPLENTE == '1'"
              title="Aviso de Inadimplência"
              color="danger"
              style="margin-bottom: 15px;"
            >
              {{ student.MSGINADIMPLENTE ? student.MSGINADIMPLENTE : 'Estudante não pode ser selecionado, pois o mesmo consta como inadimplente.' }}
            </vs-alert>

            <div class="spacing-children">
              <form>
                <vs-row>
                  <vs-col vs-w="8" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="NOMEE"
                      type="text"
                      v-model="student.NOME"
                      label="Nome Completo"
                      :disabled="disableStudentForm"
                      :danger="!student.NOME.length > 0"
                      danger-text="Campo obrigatório!"
                      v-on:blur="getNameClient(student.NOME)"
                    />
                  </vs-col>
                  <vs-col vs-w="4" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="DTNASCIMENTOE"
                      type="date"
                      v-model="student.DTNASCIMENTO"
                      label="Data de Nascimento"
                      :danger="
                        student.DTNASCIMENTO == '' ||
                        validStudentAge(student.DTNASCIMENTO)
                      "
                      danger-text="Campo obrigatório para aluno."
                      v-on:blur="getDateClient(student.DTNASCIMENTO)"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-type="flex">
                    <vs-input
                      name="NOMESOCIAL"
                      type="text"
                      v-model="student.NOMESOCIAL"
                      label="Nome Social"
                      v-on:blur="getNameSocialClient(student.NOMESOCIAL)"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="CPF"
                      type="text"
                      v-model="student.CPFCNPJ"
                      v-mask="'###.###.###-##'"
                      label="CPF"
                      :disabled="disableStudentForm"
                      :danger="!student.CPFCNPJ.length == 14"
                      danger-text="Campo obrigatório!"
                      v-on:blur="getCPFClient(student.CPFCNPJ)"
                    />
                  </vs-col>
                  <vs-col
                    vs-w="6"
                    vs-xs="12"
                    vs-type="flex"
                    v-if="student.RA == '' || student.RA == '-'"
                  >
                    <vs-select
                      width="100%"
                      v-model="student.SEXO"
                      label="Gênero"
                      :danger="student.SEXO == ''"
                      danger-text="Campo obrigatório!"
                    >
                      <vs-select-item value="M" text="Masculino" />
                      <vs-select-item value="F" text="Feminino" />
                    </vs-select>
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="4" vs-type="flex">
                    <vs-select
                      name="ESTADONATAL"
                      width="100%"
                      v-model="student.ESTADONATAL"
                      :danger="student.ESTADONATAL == ''"
                      danger-text="Estado natal obrigatório!"
                      label="Estado Natal"
                      v-on:input="changeProvincesStu($event)"
                    >
                      <vs-select-item
                        v-for="(option, i) in selectESTADO"
                        :key="i"
                        :value="option.CODIGO"
                        :text="option.NOME"
                      >
                      </vs-select-item>
                    </vs-select>
                  </vs-col>

                  <vs-col vs-w="8" vs-type="flex">
                    <vs-select
                      name="CODNATURALIDADE"
                      width="100%"
                      v-model="student.CODNATURALIDADE"
                      label="Cidade Natal"
                      :disabled="student.ESTADONATAL == ''"
                      :danger="student.CODNATURALIDADE == ''"
                      danger-text="Cidade natal obrigatória!"
                      v-on:input="getNameOfCity()"
                    >
                      <vs-select-item
                        v-for="(municipio, i) in selectCODMUNICIPIO"
                        :key="i"
                        :value="municipio.value.CODIGO"
                        :text="municipio.title"
                      />
                    </vs-select>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="6" vs-type="flex">
                    <vs-input
                      name="TELEFONEE"
                      type="text"
                      v-model="student.TELEFONE1"
                      v-mask="'(##) ####-#####'"
                      label="Telefone 1"
                      v-on:blur="
                        responsibleIsStudent || responsibleEmancipated
                          ? validTelephone(student.TELEFONE1) &&
                            student.TELEFONE1 != student.TELEFONE2
                            ? getTelefoneClient(student.TELEFONE1)
                            : ''
                          : ''
                      "
                    />
                  </vs-col>

                  <vs-col vs-w="6" vs-type="flex">
                    <vs-input
                      name="TELEFONE2E"
                      type="text"
                      v-model="student.TELEFONE2"
                      v-mask="'(##) ####-#####'"
                      label="Telefone 2"
                      v-on:blur="
                        responsibleIsStudent || responsibleEmancipated
                          ? validTelephone(student.TELEFONE1) &&
                            student.TELEFONE1 != student.TELEFONE2
                            ? getTelefone2Client(student.TELEFONE2)
                            : ''
                          : ''
                      "
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-type="flex">
                    <vs-input
                      name="EMAILE"
                      type="email"
                      v-model="student.EMAIL"
                      label="E-Mail"
                      v-on:blur="
                        responsibleIsStudent || responsibleEmancipated
                          ? student.EMAIL.length > 0 &&
                            validEmail(student.EMAIL)
                            ? getEmailClient(student.EMAIL)
                            : ''
                          : ''
                      "
                    />
                  </vs-col>
                </vs-row>
              </form>
            </div>
          </vs-card>
        </vs-row>
        <vs-row v-if="errorClient" style="margin-top: 10px">
          <vs-alert
            title="Atenção!"
            class="margin"
            color="danger"
            v-for="(error, i) in errorClient"
            :key="i"
          >
            {{ error }}
          </vs-alert>
        </vs-row>
        <vs-row v-if="errorStudent" style="margin-top: 10px">
          <vs-alert
            title="Atenção!"
            class="margin"
            color="danger"
            v-for="(error, i) in errorStudent"
            :key="i"
          >
            {{ error }}
          </vs-alert>
        </vs-row>
        <vs-row v-if="warningClient" style="margin-top: 10px">
          <vs-alert
            title="Aviso Cliente"
            class="margin"
            color="warning"
          >
            {{ warningClient }}
          </vs-alert>
        </vs-row>

        <vs-row v-if="warningStudent" style="margin-top: 10px">
          <vs-alert
            title="Aviso Estudante"
            class="margin"
            color="danger"
          >
            {{ warningStudent }}
          </vs-alert>
        </vs-row>
        <vs-row v-if="errorFinal" style="margin-top: 10px">
          <vs-alert title="Atenção!" class="margin" color="danger">
            {{ errorFinal }}
          </vs-alert>
        </vs-row>
        <vs-row v-if="showClientForm">
          <vs-col vs-type="flex" vs-justify="flex-end">
            <vs-button
              icon="check_circle"
              color="#139B0E"
              @click="saveAndGoFoward()"
            >
              Confirmar Dados e Avançar
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import {
  formatDateToUSA,
  getStepsInformation,
  notifyError,
  updateStepsInformation,
} from "../helpers";
import PersonService from "../services/person";
import SerproService from "../services/serpro";
import MailingService from "../services/mailing";
import AuditService from "../services/audits";
import { updateDiscussion } from "../helpers";
import PreRegistrationService from "../services/preRegistration";

export default {
  data: () => ({
    isTaxCpfLocked: false,
    responsibleIsStudent: true,
    responsibleEmancipated: false,
    studentAlreadySelected: false,
    address: null,
    complement: "",
    disableClientForm: false,
    disableStudentForm: false,
    client: {
      NOMESOCIAL: "",
      NOME: "",
      CGCCFO: "",
      TELEFONE: "",
      TELEX: "",
      EMAIL: "",
      PESSOAFISOUJUR: "",
      DTNASCIMENTO: "",
      isNew: false,
      RUA: "",
      CEP: "",
      NUMERO: "",
      CODMUNICIPIO: "",
      ESTADO: "RS",
      BAIRRO: "",
      TIPORUA: "",
      INADIMPLENTE: "0",
      MSGINADIMPLENTE: "",
    },
    student: {
      NOME: "",
      NOMESOCIAL: "",
      DTNASCIMENTO: "",
      ESTADONATAL: "RS",
      CODNATURALIDADE: "",
      NATURALIDADE: "",
      SEXO: "",
      CPFCNPJ: "",
      TELEFONE1: "",
      TELEFONE2: "",
      EMAIL: "",
      CODCOLCFO: "",
      CODCFO: "",
      CODPESSOA: "",
      CODFILIAL: "",
      CODTIPOCURSO: "",
      RA: "",
      isNew: false,
      MATRICULAATIVA: "0",
      IDADE: "",
      INADIMPLENTE: "0",
      MSGINADIMPLENTE: "",
    },
    selectESTADO: [],
    selectESTADOcli: [],
    selectCODMUNICIPIO: [],
    selectCODMUNICIPIOcli: [],
    selectTIPORUA: [],
    course: null,
    errorClient: null,
    errorStudent: null,
    errorFinal: null,
    showClientForm: false,
    showStudentForm: false,
    editDate: false,
    editDateStudent: false,
    editNameStudent: false,
    nascClient: "",
    nascStudent: "",
    unknownCEP: null,
    resultSerpro: null,
    cpfmenor: false,
    isEmancipated: null,
    offer: null,
    classData: null,
    noCPF: false,
    errorCEP: false,
    warningClient: null,
    warningStudent: null,
  }),
  name: "FinancialResponsible",
  mounted() {
    const stepsData = getStepsInformation();
    if (stepsData.reusedCpf) {
      this.client.CGCCFO = stepsData.reusedCpf;
      this.isTaxCpfLocked = true;
      this.findClient(this.client.CGCCFO); // Já aperta o botão "Localizar" pra ele!
    }
    this.getStates();
    this.changeProvinces("RS");
    this.offer = stepsData.offer;
    this.classData = stepsData.classData;
    this.course = stepsData.course;
    if (stepsData.student) {
      this.responsibleIsStudent = false;
      this.studentAlreadySelected = true;
      this.findStudent(stepsData.student.CPFCNPJ);
    }
  },
  methods: {
    cleanString(str) {
      if (!str) return "";
      return str
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9\s,.-]/g, "");
    },
    showForm() {
      this.showStudentForm = true;
      this.noCPF = true;
      this.editDateStudent = true;
      this.editNameStudent = true;
      this.student.ESTADONATAL = "RS";
      this.changeProvincesStu(this.student.ESTADONATAL);
      this.student.CODNATURALIDADE = "14902";
    },

    async resetDataIfNeeded() {
      if (!this.responsibleIsStudent) {
        this.resetStudent();
        this.showStudentForm = false;
      } else {
        if (this.client.CGCCFO != "") {
          await this.findStudent(this.client.CGCCFO);

          if (this.student.NOME == "") {
            this.student.CPFCNPJ = this.client.CGCCFO;
            this.showStudentForm = true;
          }
        }
      }
    },

    async formClient(cpf) {
      if (!this.responsibleEmancipated) {
        this.showClientForm = false;
      } else {
        this.client.PESSOAFISOUJUR = "F";
        this.editDate = true;
        this.client.CGCCFO = cpf;
        this.client.DTNASCIMENTO = this.nascClient;
        this.student.CPFCNPJ = cpf;
        this.showClientForm = true;
        this.errorClient = null;
      }
    },

    async getNameStudent(nome) {
      if (this.responsibleEmancipated || this.responsibleIsStudent) {
        this.student.NOME = nome;
      }
    },

    async getNameClient(nome) {
      if (this.responsibleEmancipated || this.responsibleIsStudent) {
        this.client.NOME = nome;
      }
    },

    async getNameSocialStudent(nome) {
      if (this.responsibleEmancipated || this.responsibleIsStudent) {
        this.student.NOMESOCIAL = nome;
      }
    },

    async getNameSocialClient(nome) {
      if (this.responsibleEmancipated || this.responsibleIsStudent) {
        this.client.NOMESOCIAL = nome;
      }
    },

    async getDateStudent(data) {
      if (this.responsibleEmancipated || this.responsibleIsStudent) {
        this.student.DTNASCIMENTO = data;
      }
    },

    async getDateClient(data) {
      if (this.responsibleEmancipated || this.responsibleIsStudent) {
        this.client.DTNASCIMENTO = data;
      }
    },

    async getCPFStudent(cpf) {
      if (this.responsibleEmancipated || this.responsibleIsStudent) {
        this.student.CPFCNPJ = cpf;
      }
    },

    async getCPFClient(cpf) {
      if (this.responsibleEmancipated || this.responsibleIsStudent) {
        this.client.CGCCFO = cpf;
      }
    },

    discoverAddress() {
      new PreRegistrationService()
        .getUnknownCEP(this.offer.CODCOLIGADA, this.offer.CODFILIAL)
        .then(({ data }) => {
          this.unknownCEP = data;

          this.errorCEP = false;

          this.client.CEP = this.unknownCEP.CEP;
          this.client.RUA = this.unknownCEP.RUA;
          this.client.NUMERO = this.unknownCEP.NUMERO;
          this.complement = "F";
          this.client.ESTADO = this.unknownCEP.ESTADO;
          this.client.CODMUNICIPIO = this.unknownCEP.CODMUNICIPIO;
          this.client.BAIRRO = this.unknownCEP.BAIRRO;
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        });
    },

    getNameOfCity() {
      if (
        this.student.CODNATURALIDADE != "" &&
        this.student.CODNATURALIDADE != "-"
      ) {
        let city = this.student.CODNATURALIDADE;
        const result = this.selectCODMUNICIPIO.find(
          (municipio) => municipio.value.CODIGO == city
        );
        this.student.NATURALIDADE = result.title;
      }
    },

    getStates() {
      new MailingService()
        .getStates()
        .then((res) => {
          this.selectESTADO = res.data;
          this.selectESTADOcli = res.data;
        })
        .catch((error) => {
          console.error("Error trying to fetch states and provinces", error);
        });
    },

    getAddressByCEP(cep) {
      if (this.validCEP(cep)) {
        this.$vs.loading();
        new AuditService()
          .getAddressByCEP(cep)
          .then((res) => {
            this.address = res.data;
            this.client.RUA = this.address.LOGRADOURO;
            this.client.NUMERO = "";
            this.complement = "";
            this.client.ESTADO = this.address.UF;
            this.client.BAIRRO = this.address.BAIRRO;
            this.client.CODMUNICIPIO = this.address.CODMUNICIPIO;
            this.client.TIPORUA = this.address.CODTIPORUA;
            this.errorCEP = false;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.client.RUA = "";
            this.client.NUMERO = "";
            this.complement = "";
            this.client.ESTADO = "RS";
            this.client.BAIRRO = "";
            this.client.CODMUNICIPIO = "";
            this.client.TIPORUA = "";
            this.errorCEP = true;
            notifyError(
              this,
              "CEP não encontrado, preencha o endereço manualmente"
            );
            this.$vs.loading.close();
          });
      } else {
        notifyError(this, "CEP inválido!");
      }
    },

    changeProvinces(state) {
      this.$vs.loading();
      new MailingService()
        .getCities(state)
        .then((res) => {
          let cidades = res.data.map((municipio) => ({
            value: JSON.parse(municipio.value),
            title: municipio.title,
          }));
          this.selectCODMUNICIPIOcli = cidades;
        })
        .catch((error) => {
          console.error("Error trying to fetch cities", error);
          this.$vs.notify({
            fixed: true,
            title: "Erro ao buscar cidades do estado " + state,
            color: "danger",
            icon: "close",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    changeProvincesStu(state) {
      this.selectCODMUNICIPIO = [];
      this.$vs.loading();
      new MailingService()
        .getCities(state)
        .then((res) => {
          let cidades = res.data.map((municipio) => ({
            value: JSON.parse(municipio.value),
            title: municipio.title,
          }));
          this.selectCODMUNICIPIO = cidades;
        })
        .catch((error) => {
          console.error("Error trying to fetch cities", error);
          this.$vs.notify({
            fixed: true,
            title: "Erro ao buscar cidades do estado " + state,
            color: "danger",
            icon: "close",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    async findSerpro(cpf, nascimento) {
      this.resultSerpro = null;
      this.cpfmenor = false;
      this.isEmancipated = null;
      this.$vs.loading();
      await new SerproService()
        .get(cpf.replace(/\D/g, ""), nascimento)
        .then(({ data }) => {
          this.resultSerpro = data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          const response = error.response;
          if (response) {
            if (response.status == 400) this.errorClient.push("CPF ou data de nascimento inválidos");
            if (response.status == 404) this.errorClient.push("CPF não localizado ou data de nascimento não confere com a Receita Federal");
            if (response.status == 422 || response.status == 451) {
              if (this.responsibleIsStudent) {
                this.isEmancipated = cpf;
              }
              this.errorClient.push(
                "CPF de menor de idade, não é possível buscar as informações. Preencha o formulário."
              );
              this.cpfmenor = true;
              this.student.CPFCNPJ = cpf;
            }
            if (response.status >= 500)
              this.errorClient.push(
                "O serviço de busca CPF parece não estar respondendo. Aguarde uns instantes e tente novamente."
              );
          } else {
            this.errorClient.push("Falha de comunicação com o serviço Serpro.");
          }
          this.$vs.loading.close();
        });
    },

    async findClient(cpf) {
      this.errorClient = [];
      this.errorStudent = [];
      this.responsibleEmancipated = false;
      let clientResult = null;
      this.showClientForm = false;
      this.showStudentForm = false;
      this.disableClientForm = false;
      //PESQUISA NA QI
      clientResult = await this.find(cpf, "C");
      if (clientResult) {
        const mensagemCliente =
          clientResult.MSGINADIMPLENTE && String(clientResult.MSGINADIMPLENTE).trim();

        if (mensagemCliente) {
          this.warningClient = mensagemCliente;
        }

        if (parseInt(clientResult.IDADE) < 16 && clientResult.IDADE != "0") {
          this.errorClient.push(
            "Responsável financeiro precisa ser emancipado ou maior de 18 anos."
          );
        }
        if (this.errorClient.length == 0) {
          Object.assign(this.client, clientResult);
          this.client.TELEFONE = this.client.TELEFONE1;
          this.client.TELEX = this.client.TELEFONE2;
          if (
            this.client.NOMESOCIAL == "" ||
            this.client.NOMESOCIAL == "-" ||
            this.client.NOMESOCIAL == "[object Object]"
          )
            this.client.NOMESOCIAL = this.client.NOME;
          if (this.client.DTNASCIMENTO != "-") {
            this.client.DTNASCIMENTO = formatDateToUSA(
              this.client.DTNASCIMENTO
            );
            this.editDate = false;
          } else {
            this.client.DTNASCIMENTO = "";
            this.editDate = true;
          }
          this.showClientForm = true;
          this.disableClientForm = true;
        }
      } else {
        if (cpf.length == 14) {
          //NÃO ACHA NA QI, PESQUISA NO SERPRO, EXCETO SE FOR CNPJ
          //SERPRO v3 EXIGE A DATA DE NASCIMENTO JUNTO COM O CPF
          if (!this.nascClient) {
            this.errorClient.push(
              "CPF não cadastrado na QI. Informe a data de nascimento do responsável e clique em Localizar."
            );
            return;
          }
          await this.findSerpro(cpf, this.nascClient);

          if (this.resultSerpro) {
            this.client.NOME = this.resultSerpro.nome;
            this.client.DTNASCIMENTO = formatDateToUSA(
              this.resultSerpro.nascimento
            );
            this.client.PESSOAFISOUJUR = "F";
            this.client.NOMESOCIAL = this.client.NOME;
            this.editDate = false;
            this.showClientForm = true;
            this.showStudentForm = true;
          } else {
            this.resetClient();
            this.showClientForm = true;
            this.showStudentForm = true;
          }
        } else if (cpf.length > 14) {
          //SE FOR CNPJ MOSTRA O FORMULÁRIO PARA CADASTRO
          this.showClientForm = true;
          this.client.PESSOAFISOUJUR = "J";
          this.editDate = false;
        }
      }
      //SE O RESPONSÁVEL E ALUNO SÃO A MESMA PESSOA
      if (this.responsibleIsStudent) {
        //TENTA LOCALIZAR O ALUNO NA QI
        await this.findStudent(cpf);
        if (this.student.NOME == "") {
          //NÃO TEM NA QI, copia os dados do cliente
          this.student.NOME = this.client.NOME;
          this.student.NOMESOCIAL = this.client.NOMESOCIAL;
          this.student.DTNASCIMENTO = this.client.DTNASCIMENTO;
          this.student.CPFCNPJ = this.client.CGCCFO;
          this.student.ESTADONATAL = "RS";
          this.changeProvincesStu(this.student.ESTADONATAL);
          this.student.CODNATURALIDADE = "14902";
          this.student.TELEFONE1 = this.client.TELEFONE;
          this.student.TELEFONE2 = this.client.TELEX;
          this.student.EMAIL = this.client.EMAIL;
          this.student.isNew = true;
          this.editDateStudent = false;
          this.showStudentForm = true;
        }
      }
    },

    resetClient() {
      this.client = {
        CGCCFO: "",
        NOMESOCIAL: "",
        NOME: "",
        TELEFONE: "",
        TELEX: "",
        EMAIL: "",
        PESSOAFISOUJUR: "",
        DTNASCIMENTO: "",
        RUA: "",
        CEP: "",
        NUMERO: "",
        COMPLEMENTO: "",
        CODMUNICIPIO: "",
        ESTADO: "RS",
        BAIRRO: "",
        TIPORUA: "",
        INADIMPLENTE: "0",
        MSGINADIMPLENTE: "",
      };
    },

    resetStudent() {
      this.errorStudent = [];
      this.student = {
        NOME: "",
        NOMESOCIAL: "",
        DTNASCIMENTO: "",
        ESTADONATAL: "RS",
        CODMUNICIPIONATURALIDADE: "",
        NATURALIDADE: "",
        SEXO: "",
        CPFCNPJ: "",
        TELEFONE1: "",
        TELEFONE2: "",
        EMAIL: "",
        CODCOLCFO: "",
        CODCFO: "",
        CODPESSOA: "",
        CODFILIAL: "",
        CODTIPOCURSO: "",
        MATRICULAATIVA: "0",
        RA: "",
        IDADE: "",
        INADIMPLENTE: "0",
        MSGINADIMPLENTE: "",
      };
    },

    async findStudent(cpf) {
      this.resetStudent();
      this.warningStudent = null;
      const cleanCpf = cpf ? cpf.replace(/\D/g, "") : "";
      if (cleanCpf.length !== 11) {
        this.errorStudent.push("Por favor, preencha um CPF válido com 11 dígitos antes de localizar.");
        return;
      }
      //PESQUISA NA QI
      this.resetStudent();
      this.warningStudent = null;
      let studentResult = null;
      this.editNameStudent = false;
      this.disableStudentForm = false;
      studentResult = await this.find(cpf, "A");
      if (studentResult) {
        const mensagemAluno = studentResult.MSGINADIMPLENTE && String(studentResult.MSGINADIMPLENTE).trim();
        if (studentResult.INADIMPLENTE == "1" && mensagemAluno) {
          this.warningStudent = mensagemAluno;
        }
        if (this.errorStudent.length == 0) {
          Object.assign(this.student, studentResult);
          this.student.RA = studentResult.RA;
          if (
            this.student.NOMESOCIAL == "" ||
            this.student.NOMESOCIAL == "-" ||
            this.student.NOMESOCIAL == "[object Object]"
          )
            this.student.NOMESOCIAL = this.student.NOME;
          if (
            this.student.DTNASCIMENTO != "-" &&
            this.student.DTNASCIMENTO != ""
          ) {
            this.student.DTNASCIMENTO = formatDateToUSA(
              this.student.DTNASCIMENTO
            );
            this.editDateStudent = false;
          }
          if (studentResult.FUNCIONARIO == "1") {
            this.noEdit = false;
            this.errorStudent.push(
              "Funcionário ativo na Instituição, seus dados pessoais não serão alterados. Caso necessário, entre em contato com RH para alteração."
            );
          }
          this.showStudentForm = true;
          this.disableStudentForm = true;
        }
      } else if (!this.responsibleIsStudent) {
        //NÃO TEM NA QI, RESP NÃO É O ESTUDANTE, PESQUISA NO SERPRO
        //SERPRO v3 EXIGE A DATA DE NASCIMENTO JUNTO COM O CPF
        if (!this.nascStudent) {
          this.student.CPFCNPJ = cpf;
          this.errorStudent.push(
            "CPF não cadastrado na QI. Informe a data de nascimento do estudante e clique em Localizar Estudante."
          );
          return;
        }
        await this.findSerpro(cpf, this.nascStudent);
        if (this.resultSerpro) {
          this.student.NOME = this.resultSerpro.nome;
          this.student.NOMESOCIAL = this.student.NOME;
          this.student.CPFCNPJ = cpf;
          this.student.ESTADONATAL = "RS";
          this.student.DTNASCIMENTO = formatDateToUSA(
            this.resultSerpro.nascimento
          );
          this.editDateStudent = false;
          this.showStudentForm = true;
        } else {
          //NÃO LOCALIZOU NO SERPRO, VE SE É CPF DE MENOR DE IDADE
          if (this.cpfmenor) {
            this.editDateStudent = true;
            this.editNameStudent = true;
            this.showStudentForm = true;
            this.student.ESTADONATAL = "RS";
            this.student.DTNASCIMENTO = this.nascStudent;
          } else {
            this.resetStudent();
            this.showStudentForm = true;
          }
        }
      }

      this.changeProvincesStu(this.student.ESTADONATAL);
    },

    validTelephone(telephone) {
      var re = /^(\(?\d{2}\)?\s)(\d{4}?-\d{4,5})$/;
      return re.test(telephone);
    },
    validCEP(cep) {
      var re = /^\d{5}\d{3}$/;
      return re.test(cep);
    },

    validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValidStructure = re.test(email);
      const hasValidTld = email.toLowerCase().endsWith('.com') || email.toLowerCase().endsWith('.br') || email.toLowerCase().endsWith('.org') || email.toLowerCase().endsWith('.gov') || email.toLowerCase().endsWith('.net') || email.toLowerCase().endsWith('.edu');

      return isValidStructure && hasValidTld;

    },

    validClientAge(birthDay) {
      if (this.responsibleEmancipated || this.client.EMANCIPADO == "S") {
        return (
          moment().diff(moment(birthDay).format("YYYY-MM-DD"), "years") < 16
        );
      } else {
        return (
          moment().diff(moment(birthDay).format("YYYY-MM-DD"), "years") < 18
        );
      }
    },

    validStudentAge(birthDay) {
      return moment().diff(moment(birthDay).format("YYYY-MM-DD"), "years") <= 0;
    },

    validAddress() {
      if (
        this.client.RUA != "" &&
        this.client.NUMERO != "" &&
        this.client.ESTADO != "" &&
        this.client.BAIRRO != "" &&
        this.client.CODMUNICIPIO != "" &&
        this.client.CODMUNICIPIO != "-" &&
        this.validCEP(this.client.CEP)
      ) {
        return true;
      } else return false;
    },

    validClientData() {
      this.errorClient = [];
      if (!this.validEmail(this.client.EMAIL))
        this.errorClient.push("E-mail do responsável financeiro inválido.");
      if (
        this.validClientAge(this.client.DTNASCIMENTO) &&
        !this.responsibleEmancipated &&
        this.client.EMANCIPADO != "S"
      )
        this.errorClient.push(
          "Data de nascimento do responsável inválida. Lembramos que o responsável financeiro precisa ter 18 anos completos."
        );
      if (!this.validTelephone(this.client.TELEFONE))
        this.errorClient.push("Telefone 1 do responsável inválido.");
      if (!this.validTelephone(this.client.TELEX))
        this.errorClient.push("Telefone 2 do responsável inválido.");
      if (this.client.NOME == "")
        this.errorClient.push("O nome do cliente precisa ser preenchido");
      if (!this.validAddress())
        this.errorClient.push("Preencha o endereço do cliente!");
    },

    validStudentData() {
      this.errorStudent = [];
      if (this.validStudentAge(this.student.DTNASCIMENTO))
        this.errorStudent.push("Data de nascimento do estudante inválida.");
      this.student.NOME = this.student.NOME.trim();
      if (
        this.student.NOME == "" ||
        this.student.NOME == "-" ||
        this.student.NOME.indexOf(" ") == -1
      )
        this.errorStudent.push(
          "O nome completo do estudante precisa ser preenchido"
        );

      if (
        this.noCPF &&
        !this.validClientAge(this.student.DTNASCIMENTO) &&
        this.student.CPFCNPJ.length != 14
      ) {
        this.errorStudent.push(
          "Para alunos a partir de 18 anos é necessário informar o CPF."
        );
      }
      if (this.student.ESTADONATAL == "" || this.student.ESTADONATAL == "-")
        this.errorStudent.push(
          "O estado natal do estudante precisa ser preenchido"
        );
      if (
        this.noCPF == false &&
        (this.student.CODNATURALIDADE == "" ||
          this.student.CODNATURALIDADE == "-" ||
          this.student.NATURALIDADE == "")
      )
        this.errorStudent.push(
          "A cidade natal do estudante precisa ser preenchida"
        );

      if (this.student.IDADE == "" || this.student.IDADE == "-")
        this.student.IDADE = moment().diff(
          moment(this.student.DTNASCIMENTO).format("YYYY-MM-DD"),
          "years"
        );

      if (parseInt(this.student.IDADE) < parseInt(this.offer.IDADEMINIMA)) {
        this.errorStudent.push(
          `Estudante não tem a idade mínima exigida para o curso que é de ${this.offer.IDADEMINIMA} anos.`
        );
      }
      if (
        this.student.MATRICULAATIVA == "1" &&
        (parseInt(this.course.IDCLASSIFICACAO) < 79 ||
          parseInt(this.course.IDCLASSIFICACAO) > 83)
      ) {
        this.errorStudent.push(
          `Estudante já possui matrícula ativa no curso selecionado ou já existe uma pré-matrícula lançada em andamento.`
        );
      }
    },

    async find(cpf, type) {
      this.$vs.loading();
      let result = null;
      await new PersonService()
        .getPerson(cpf.replace(/\D/g, ""), null, this.offer.CODCURSO, type)
        .then(({ data }) => {
          result = data;
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
          this.$vs.loading.close();
        });
      return result;
    },

    async saveClient() {
      const clientData = {
        NOMEFANTASIA: this.client.NOMESOCIAL,
        NOME: this.client.NOME,
        CGCCFO: this.client.CGCCFO.replace(/\D/g, ""),
        TELEFONE: this.client.TELEFONE.replace(/\D/g, ""),
        TELEX: this.client.TELEX.replace(/\D/g, ""),
        EMAIL: this.client.EMAIL,
        PESSOAFISOUJUR: this.client.PESSOAFISOUJUR,
        DTNASCIMENTO: this.client.DTNASCIMENTO,
        CODCOLCFO: this.client.CODCOLIGADA,
        CODCFO: this.client.CODCFO,
        CIDENTIDADE: this.client.RG,
        CEP: this.client.CEP == "-" ? "" : this.client.CEP,
        RUA: this.cleanString(this.client.RUA == "-" ? "" : this.client.RUA),
        NUMERO: this.cleanString(this.client.NUMERO == "-" ? "" : this.client.NUMERO),
        COMPLEMENTO: this.cleanString(this.complement),
        CODETD: this.client.ESTADO == "-" ? "" : this.client.ESTADO,
        CODMUNICIPIO: this.client.CODMUNICIPIO == "-" ? "" : this.client.CODMUNICIPIO,
        BAIRRO: this.cleanString(this.client.BAIRRO == "-" ? "" : this.client.BAIRRO),
        TIPORUA: this.client.TIPORUA == "-" ? "" : this.client.TIPORUA,
        EMANCIPADO:
          this.responsibleEmancipated || this.client.EMANCIPADO == "S"
            ? "S"
            : "",
        isNew: this.client.isNew,
      };
      await new PersonService()

        .newClientPerson(clientData)
        .then(({ data }) => {
          const result = data.split(";");
          this.student.CODCFO = result[1];
          this.client.CODCFO = result[1];
          this.student.CODCOLCFO = result[0];
          this.client.CODCOLCFO = result[0];
        })
        .catch((error) => {
          this.errorClient.push(
            "Erro na tentativa de criar ou atualizar um registro de cliente: " +
              error.response.data.error
          );
        });
    },

    async savePerson() {
      let city = this.client.CODMUNICIPIO;
      const result = this.selectCODMUNICIPIOcli.find(
        (municipio) => municipio.value.CODIGO == city
      );
      this.student.CIDADE = result.title;

      this.getNameOfCity();
      const studentData = {
        NOME: this.student.NOME,
        NOMESOCIAL: this.student.NOMESOCIAL,
        DTNASCIMENTO: this.student.DTNASCIMENTO,
        ESTADONATAL: this.student.ESTADONATAL,
        CODNATURALIDADE: this.student.CODNATURALIDADE,
        NATURALIDADE: this.student.NATURALIDADE,
        SEXO: this.student.SEXO,
        CPFCNPJ: this.student.CPFCNPJ.replace(/\D/g, ""),
        TELEFONE1:
          !this.student.TELEFONE1 || this.student.TELEFONE1 == "("
            ? this.client.TELEFONE.replace(/\D/g, "")
            : this.student.TELEFONE1.replace(/\D/g, ""),
        TELEFONE2:
          !this.student.TELEFONE2 || this.student.TELEFONE2 == "("
            ? this.client.TELEX.replace(/\D/g, "")
            : this.student.TELEFONE2.replace(/\D/g, ""),
        EMAIL:
          !this.student.EMAIL || this.student.EMAIL == "-"
            ? this.client.EMAIL
            : this.student.EMAIL,
        isNew: this.student.isNew,
        CODPESSOA: this.student.CODPESSOA,
        CIDADE: this.cleanString(this.student.CIDADE),
        BAIRRO: this.cleanString(this.client.BAIRRO),
        CEP: this.client.CEP,
        RUA: this.cleanString(this.client.RUA),
        NUMERO: this.cleanString(this.client.NUMERO),
        COMPLEMENTO: this.cleanString(this.complement),
        ESTADO: this.client.ESTADO,
      };
      await new PersonService()
        .newPerson(studentData)
        .then(({ data }) => {
          this.student.CODPESSOA = data;
        })
        .catch((error) => {
          this.errorStudent.push(error.response.data.error);
        });
    },

    async createStudent() {
      const student = {
        RA: 0,
        CODCOLCFO: this.student.CODCOLCFO,
        CODCFO: this.student.CODCFO,
        CODPESSOA: this.student.CODPESSOA,
        CODFILIAL: this.student.CODFILIAL,
        CODTIPOCURSO: this.student.CODTIPOCURSO,
        isNew: this.student.isNew,
      };
      await new PersonService()
        .newStudentPerson(student)
        .then(({ data }) => {
          this.student.RA = data;
        })
        .catch(({ error }) => {
          console.log(error);
          this.errorStudent.push(
            "Erro na tentativa de criar ou atualizar um registro de estudante"
          );
        });
    },

    async getTelefone(telefone) {
      this.student.TELEFONE1 = telefone;
    },

    async getTelefoneClient(telefone) {
      this.client.TELEFONE = telefone;
    },

    async getTelex(telex) {
      this.student.TELEFONE2 = telex;
    },

    async getTelefone2Client(telefone) {
      this.client.TELEX = telefone;
    },

    async getEmail(email) {
      this.student.EMAIL = email;
    },

    async getEmailClient(email) {
      this.client.EMAIL = email;
    },

    async saveAndGoFoward() {
      this.errorClient = [];
      this.errorStudent = [];
      this.errorFinal = null;

      if (this.client.INADIMPLENTE == '1' || this.student.INADIMPLENTE == '1') {
        this.errorFinal = this.client.MSGINADIMPLENTE;
        return;
      }

      this.validClientData();
      if (this.errorClient.length == 0) {
        this.$vs.loading();
        if (!this.client.CODCFO) this.client.isNew = true;
        else this.client.isNew = false;
        await this.saveClient();
        this.validStudentData();
        /*if (!this.responsibleIsStudent) {
          if ((this.client.NOME == this.student.NOME) && (this.client.CGCCFO == this.student.CPFCNPJ)) {
            this.errorClient.push(
              "Erro na tentativa de criar ou atualizar um registro de cliente: Aluno deve ser diferente do responsável financeiro"
            );
          }
        }*/
        if (this.errorStudent.length == 0 && this.errorClient.length == 0) {
          if (!this.student.CODPESSOA) this.student.isNew = true;
          else this.student.isNew = false;
          if (this.student.FUNCIONARIO != "1") {
            await this.savePerson();
          }
          if (
            (this.student.RA == "" || this.student.RA == "-") &&
            this.errorStudent.length == 0
          ) {
            this.student.CODFILIAL = this.offer.CODFILIAL;
            this.student.CODTIPOCURSO = this.classData.CODTIPOCURSO;
            await this.createStudent();
          }
        }
        this.$vs.loading.close();
      } //fecha if - se não tem erros no cliente
      if (
        // se não deu erro, segue adiante
        this.student.RA != "" &&
        this.student.RA != "-1" &&
        this.student.CODPESSOA != "" &&
        this.client.CODCFO != "" &&
        this.errorStudent.length == 0 &&
        this.errorClient.length == 0
      ) {
        updateDiscussion("Selecionou Responsável e Estudante", {
          cpfResponsavel: this.client.CGCCFO,
          cpfAluno: this.student.CPFCNPJ,
        }).finally(() => {
          updateStepsInformation({
            client: this.client,
            student: this.student,
          });
          this.$router.push("/reviewInformation");
        });
      } else {
        this.errorFinal = `Não é possível seguir adiante com os dados selecionados:
        RA: ${this.student.RA}, código de cliente: ${this.client.CODCFO} e
        código de Pessoa: ${this.student.CODPESSOA}`;
      }
    },
  },
};
</script>
